import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ContextualCreatePopoverProps } from '../src/CreateContentPopover/ContextualCreateContentPopover/ContextualCreateContentPopover.tsx';

export const ContextualCreateContentPopoverLoader: LoadableType<ContextualCreatePopoverProps> =
	LoadableAfterPaint<ContextualCreatePopoverProps>({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContextualCreatePopover" */ '../src/CreateContentPopover/ContextualCreateContentPopover/ContextualCreateContentPopover.tsx'
				)
			).ContextualCreateContentPopover,
	});
